// Messages for portal/Login (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.login.head': 'Sign in — Customer portal',
  'portal.login.title': 'Sign in',
  'portal.login.subtitle': 'Geo4Logistics customer portal',
  'portal.login.email': 'Email',
  'portal.login.password': 'Password',
  'portal.login.remember': 'Keep me signed in on this device',
  'portal.login.submit': 'Sign in',
  'portal.login.magic_link': 'Email me a sign-in link',
}

export const zhTW = {
  'portal.login.head': '登入 — 客戶入口',
  'portal.login.title': '登入',
  'portal.login.subtitle': 'Geo4Logistics 客戶入口',
  'portal.login.email': '電子郵件',
  'portal.login.password': '密碼',
  'portal.login.remember': '在此裝置上保持登入',
  'portal.login.submit': '登入',
  'portal.login.magic_link': '寄送登入連結給我',
}
